export default "__VITE_ASSET__CpB$1$gQ__"